import { useStableProps } from '@/hooks/useStable';
import { StandaloneArticleFooter } from 'base/components/ArticleFooter';

export const ElleStandaloneArticleFooter: typeof StandaloneArticleFooter = (props) => {
  const stableProps = useStableProps({ options: { $tags: { align: 'center' } } }, props);

  return (
    <>
      <StandaloneArticleFooter {...stableProps} />
    </>
  );
};

export default ElleStandaloneArticleFooter;
